module.exports = __webpack_public_path__ + "img/1F61D.70fc77ed.svg";